import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DestinationsRepository } from '@/core/domain/destinations/repositories/destinations.repository';
import { GetDestinationsUseCase } from '@/core/domain/destinations/usecases/getDestinations.usecase';
import { DestinationsImplRepository } from './destinations-impl.repository';

const getDestinationsUseCaseFactory = (
    destinationsRepository: DestinationsRepository,
) => new GetDestinationsUseCase(destinationsRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: GetDestinationsUseCase,
            useFactory: getDestinationsUseCaseFactory,
            deps: [DestinationsRepository],
        },
        {
            provide: DestinationsRepository,
            useClass: DestinationsImplRepository,
        },
    ],
})
export class DestinationsDataModule {}
